export default {
  aggregates: {
    aggregated: 'Sammanslagna resultat',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'sedan',
    from: 'från',
    since: 'sedan',
    unit: {
      DAY: 'dag | dagar',
      MONTH: 'månad | månader',
      YEAR: 'år | år'
    },
    untilNow: 'till nu'
  },
  categoryDetails: {
    average: 'Medelvärde. {benchmark}',
    chartLabel: {
      noLabel: 'Nej',
      yesLabel: 'Ja'
    },
    condensedQuestionTitlePrefix: 'Uppföljningsfrågor för',
    description:
      'Här visas hur teamets svar på alla frågor i kategorin är fördelade.',
    hideOwnAnswers: 'Dölj egna svar',
    noResponses: 'Inga svar',
    notParticipating: 'Du har inte själv svarat på de här frågorna.',
    numberOfPeople: 'Deltagare',
    sensitiveQuestion: 'Detta kan bara du som chef se.',
    showFollowUpQuestions: 'Visa uppföljande frågor',
    showFollowUpQuestionsCondensed: 'Sammanfattad vy',
    toggleButton: {
      overview: 'Översikt',
      questions: 'Frågor'
    },
    tooltip: {
      barValue: 'ingen | {count} person | {count} personer',
      barValueAnswers: 'ingen | {count} svar | {count} svar',
      barValueCondensed: 'svarade {label}',
      noHistoryForQuestion:
        'Den här frågan har inte ställts tidigare under den valda tidsperioden.',
      nooneFollowupQuestionsRelevant:
        'Det finns inga relevanta svar på en uppföljande fråga',
      nooneFollowupQuestionsSameLabel:
        'Ingen har svarat {yesLabel} på en uppföljande fråga',
      nooneOtherQuestionsCondensed:
        'Ingen har svarat {yesLabel} på övriga uppföljande frågor'
    },
    workWith: 'Hur du jobbar med {categoryName}',
    yourResponse: 'Du svarade:'
  },
  error: {
    couldNotLoadAggregates: 'Kunde inte hämta ner sammanslagna undersökningar.',
    couldNotLoadResults: 'Kunde inte hämta ner resultat.',
    networkError:
      'Det gick inte att ladda data från Internet. Fungerar anslutningen?',
    unknown: 'Oops! Det inträffade ett okänt fel.'
  },
  errors: {
    status: {
      BadRequest: 'Felaktig förfrågan till servern',
      Forbidden: 'Det här är inte tillgängligt för dig',
      InternalServerError:
        'Något gick fel på servern. Kontakta oss om det här fortsätter hända.',
      NotFound: 'Kunde inte hitta det du letar efter',
      Unauthorized: 'Du har inte behörighet att se det här',
      UnknownError: 'Okänt fel inträffade'
    }
  },
  freetext: {
    loadResponses: 'Ladda svar',
    noFreeTextQuestions:
      'När du har fritextfrågor i din undersökning kan du se alla svar här.',
    notEnoughResponses: 'Inte tillräckligt många svar.',
    responses: 'Inga svar | {count} svar | {count} svar'
  },
  general: {
    add: 'Lägg till',
    cancel: 'Avbryt',
    entireOrganization: 'Hela organisationen',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} är det genomsnittliga värdet av alla svar inom {title}. {compareToBenchmark}',
    currentValue: 'Nuvarande värde',
    filter: {
      findGroups: 'Hitta grupper',
      shouldExportWithHierarchy: 'Inkludera underliggande grupper'
    },
    loadMore: 'Ladda fler',
    loadMoreInGroup: 'Ladda fler inom {groupName}',
    noone: 'Ingen har svarat',
    noResults:
      'Inte tillräckligt många svar för den här gruppen ännu. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'har svarat',
    nps: 'Net Promoter Score',
    nps_detractors: 'Kritiker',
    nps_passives: 'Passiva',
    nps_promoters: 'Förespråkare',
    questions: 'Frågor i kategorin',
    showTrend: 'Visa förändring',
    selectTableGroups: 'Välj grupper att visa',
    groupSelectorDescription:
      'Välj vilka grupper som du vill ska synas i jämförelsevyn.',
    selectAll: 'Alla',
    enableTrend: 'Visa trend',
    showSensitive: 'Visa känsliga',
    violationsIn:
      'Det har rapporterats att det förekommer kränkningar inom {groupName}. Ta kontakt med HR avdelningen som kan berätta mer och stötta dig i att jobba med frågan framöver.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Välj datum som startpunkt för historiken.',
      selectDate: 'Visar historik för undersökningar sedan {date}.',
      selectedDate: 'Visar historik sedan {date}.'
    },
    selectorOptions: {
      custom: 'anpassat',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Försök igen'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Undersökningar',
    help: 'Hjälp',
    myActivities: 'Actions',
    ourResults: 'Resultat',
    overview: 'Översikt',
    team: 'Team',
    welcome: 'Välkommen'
  },
  page: {
    results: 'Alla resultat'
  },
  resultDetails: {
    backToResults: 'Tillbaka',
    exportData: 'Exportera',
    exportModal: {
      includeSensitiveQuestions: 'Inkludera känsliga frågor',
      loadingMessage:
        'Förbereder data för export, det här kan ta en liten stund.',
      saveAsExcelAllGroupsDescription:
        'Du kommer att få en Excel-fil med resultat för {groupTitle} och alla underliggande grupper. Användbar när du vill analysera många gruppers resultat i detalj eller göra egna beräkningar.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Du kommer att få en Excel-fil med resultat för {groupTitle}{segmentInfo}. Användbar när du vill analysera resultaten i detalj eller göra egna beräkningar.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Genom att exportera till PDF får du en fil innehållande resultat för varje kategori och fråga för vald grupp. Bra för att skriva ut och dela med andra.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'En PowerPoint-export ger dig en snygg presentation av resultaten för {groupTitle}{segmentInfo}. Perfekt när du vill visa för andra på en stor skärm.'
    },
    notes: {
      draggable: {
        explanation: 'Syns bara för dig',
        placeholder:
          'Skriv dina egna anteckningar, kommentarer och reflektioner om undersökningen här',
        title: 'Egna anteckningar'
      },
      status: {
        initial: 'Sparar automatiskt när du skriver',
        saved: 'Ändringar sparade!',
        unsaved: 'Sparar snart...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Inte tillräckligt många svar för att kunna se resultat per användare'
        },
        description: {
          high: 'En person svarade så genomsnittsvärdet blev grönt.|{count} personer svarade så deras genomsnittsvärde blev grönt.',
          low: 'En person svarade så genomsnittsvärdet blev rött.|{count} personer svarade så deras genomsnittsvärde blev rött.',
          medium:
            'En person svarade så genomsnittsvärdet blev gult|{count} personer svarade så deras genomsnittsvärde blev gult.'
        },
        title: 'Ingen|En person|{count} personer'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Ni ligger lika med Pulsᐩ-benchmark® för {title}.',
        higherThanBenchmarkValue:
          'Ni ligger {benchmarkDiff} högre än Pulsᐩ-benchmark® för {title} som är {benchmarkValue}. Snyggt!',
        lowerThanBenchmarkValue:
          'Ni ligger {benchmarkDiff} lägre än Pulsᐩ-benchmark® för {title} som är {benchmarkValue}.',
        percentagePoints: 'procentenheter'
      },
      enps: {
        button: {
          description:
            'Du kommer skickas till vår partner, EQI, som samlar jämförelsedata från ett stort antal organisationer och erbjuder mer detaljerade insikter kring ert eget eNPS-resultat.',
          title: 'Jämför ditt eNPS-resultat med andra organisationer'
        }
      },
      toggleButton: {
        history: 'Historik',
        overview: 'Översikt'
      }
    }
  },
  results: {
    aggregated: 'Sammanslagna',
    chooseSurvey: 'Välj undersökning',
    finished: 'Avslutade',
    published: 'Pågående',
    noSurveys: 'Inget resultat att visa',
    reloadSurveys: 'Ladda om'
  },
  resultsmessages: {
    historyTitle: 'Konversationshistorik',
    newMessage: 'Ny konversation',
    clearHistory: 'Rensa historik',
    disclaimer: 'Pulsᐩ AI använder generativ AI och kan göra misstag.',
    error: {
      generic: 'Uh oh, något gick fel. Försök att ladda om sidan.',
      notEnoughResults:
        'Det finns inget resultat att diskutera kring. Välj en annan grupp eller undersökning för att använda Pulsᐩ AI.'
    },
    moreInfo: 'Läs mer om att använda Pulsᐩ AI i ditt ledarskap',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Skriv en fråga om resultatet...',
    reload: 'Ladda om',
    report: 'Rapportera problem',
    send: 'Skicka',
    suggestionHeader: 'Här är några förslag på vad du kan fråga om:',
    suggestions: {
      groupsComparison: {
        1: 'Vilka grupper bör jag fokusera på?',
        2: 'Finns det någon fråga som de flesta grupper bör arbeta med?',
        3: 'Vilka grupper visar negativa trender?',
        4: 'Vilka grupper har positiva trender?',
        5: 'Vilka grupper sticker ut negativt?',
        6: 'Vilka grupper behöver min uppmärksamhet?',
        7: 'Vad ska jag göra först?'
      },
      overview: {
        1: 'Vad ska jag göra med vårt resultat?',
        2: 'Hur ska jag presentera detta för mitt team?',
        3: 'Överlag, hur ser resultatet ut?',
        4: 'Vilka topp 3 åtgärder bör vi göra?',
        5: 'Vad kan jag förbättra i mitt ledarskap?',
        6: 'Vilka risker har vi?',
        7: 'Vad kan ske om vi inte agerar?',
        8: 'Vad bör jag prioritera?',
        9: 'Hur ser prognosen ut för {groupName}?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Alla'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Jämförelser'
        },
        export: {
          title: 'Export'
        },
        freetext: {
          title: 'Fritext'
        },
        results: {
          title: 'Resultat'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Det är inte möjligt att visa statistik utan att riskera tappa anonymiteten.',
    others: 'Övrig | Övriga',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administration',
    currentSurveys: 'Pågående undersökningar',
    dashboard: 'Översikt',
    help: 'Hjälp',
    logOut: 'Logga ut',
    myActivities: 'Mina aktiviteter',
    ourResults: 'Våra resultat'
  },
  topbanner: {
    preview: {
      body: 'Du tittar nu på den nya versionen av Pulsᐩ resultatvy där vi har gjort många förbättringar och förenklingar. Vi hoppas du gillar den!',
      header: 'Ny version!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Under tidsperioden {startDate} - {endDate} har resultatet minskat för {categoryName}.',
        trend_increased:
          'Under tidsperioden {startDate} - {endDate} har resultatet ökat för {categoryName}. Fortsätt så!',
        trend_same:
          'Resultatet är oförändrat för {categoryName} under tidsperioden {startDate} - {endDate}.'
      }
    },
    noTrend: 'Det finns ingen tidigare undersökning att jämföra med.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Jämfört med den tidigare undersökningen {oldSurveyDate} har resultatet minskat med {changeInPercent}% för {tagName}.',
        nps_trend_increased:
          'Jämfört med den tidigare undersökningen {oldSurveyDate} har resultatet ökat med {changeInPercent}% för {tagName}.',
        nps_trend_same:
          'Resultatet har förblivit ungefär det samma ({changeInPercent}% förändring) för {tagName} sedan undersökningen {oldSurveyDate}.',
        trend_decreased:
          'Under tidsperioden {startDate} - {endDate} har resultatet minskat för {tagName}.',
        trend_increased:
          'Under tidsperioden {startDate} - {endDate} har resultatet ökat för {tagName}.',
        trend_same:
          'Resultatet är oförändrat för {tagName} under tidsperioden {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Alla grupper',
    cannotChangeGroupsWhileComparing:
      'I jämförelsevyn tittar du på resultat för flera grupper samtidigt.',
    group: 'Grupp',
    segment: 'Segment',
    survey: 'Undersökning'
  },
  widgetResultsMessages: {
    historyTitle: 'Övergripande resultat',
    waiting: 'Väntar på svar från Pulsᐩ AI...',
    loading: 'Laddar personliga insikter...',
    error: {
      generic: 'Kunde inte ladda in Pulsᐩ AI. Prova igen om en stund.'
    },
    retry: 'Prova igen'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction: 'Antal personer som valde minst en aktivitet',
      totalActions: 'Totalt antal valda aktiviteter'
    },
    title: 'Summering för aktivitetsval'
  },
  widgetAlert: {
    actions: {
      saved: 'Tack, aktiviteten har sparats.'
    },
    links: {
      tooltip: 'Länken öppnas i nytt fönster'
    },
    notEnoughData: 'Det finns ingenting att visa här just nu.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Rapporterades senast {surveyDate}.'
      },
      question: {
        resultsFromManyAggregates: 'Visar resultat från dessa undersökningar:',
        info: 'Frågan senast ställd {surveyDate} i "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Det finns ännu inte tillräckligt många svar för att visa något här.',
    title: 'Kategorier',
    toggles: {
      currentSurveysOnly: {
        description: 'Visa endast resultat för {surveyName}',
        title: 'Denna undersökning',
        valueDescription: 'Visar resultat för {surveyName}'
      }
    },
    tooltip: {
      value:
        'Det här är genomsnittsvärdet för alla frågor inom "{categoryName}" som besvarats av {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Ett oväntat fel inträffade när widgeten skulle laddas. Försök först att ladda om sidan. Om det inte hjälper är vi tacksamma om du rapporterar problemet till oss så ska vi lösa det så snabbt som möjligt.',
    hideErrorDetails: 'Dölj felinformation',
    showErrorDetails: 'Visa felinformation',
    title: 'Problem med widget'
  },
  widgetGroupActions: {
    allCategories: 'Inom alla kategorier',
    freeText: {
      alert: {
        noResults: 'Ingenting hittades, prova skriv något annat!',
        typeMore: 'Skriv lite till'
      },
      filterField: {
        placeholder: 'Hitta kommentarer'
      },
      numberOfComments: '{numberOfComments} kommentarer'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/886432805',
        title: 'Så utvecklar du eget ansvar hos medarbetarna'
      }
    },
    noActions: 'Det finns inga aktiviteter att visa.',
    noActionsSelectedInCategory: 'Det finns inga aktiviteter valda',
    otherActions: 'Egna aktiviteter',
    people:
      'inga aktivitetsval | {count} aktivitetsval | {count} aktivitetsval',
    peopleSelectedActions:
      'Av {peopleResponded} som besvarade undersökningen har en person valt minst en aktivitet ({percentage}%).| Av {peopleResponded} personer som svarade så valde {count} personer minst en aktivitet  ({percentage}%).',
    title: 'Valda aktiviteter för {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 person har valt den här aktivitet| {count} personer har valt den här aktivitet'
    }
  },
  widgetGroupPriorities: {
    description:
      'Medarbetarna tycker att detta är det viktigaste att fokusera på just nu',
    freeTextResponses: 'Visa fritextsvar',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/886432528',
        title: 'Hur du utvecklar ditt team med Pulsᐩ'
      }
    },
    noPriorities: 'Det finns inga prioriterade områden valda av medarbetarna.',
    people: 'ingen | {count} person | {count} personer',
    thinkImportant: ' tycker "{category}" är viktigast',
    title: 'Prioriteringar för {groupName}'
  },
  widgetNotImplemented: {
    content: 'Funktionen är inte klar ännu'
  },
  widgetSurveyInfo: {
    endDate: 'Slutdatum:',
    noone: 'Ingen har svarat',
    notEnoughResponses: {
      aggregate:
        'Inte tillräckligt många svar under perioden för att kunna visa resultat.',
      completed:
        'Inte tillräckligt många personer svarade för att kunna visa resultat.',
      published:
        'Ännu inte tillräckligt många personer som svarat för att kunna visa resultat.'
    },
    participation: {
      title: 'Deltagande'
    },
    startDate: 'Startdatum:',
    status: {
      completed:
        'Undersökningen är avslutad! Det här är de slutgiltiga resultaten.',
      published: 'Undersökningen pågår fortfarande. Resultat är preliminära.'
    },
    usersInvited: 'Inbjudna personer:',
    usersResponded: 'Personer som svarade:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Det här är de senaste resultaten för {groupName}.'
    },
    notEnoughResponses:
      'Det finns ännu inte tillräckligt många svar för att visa något här.',
    title: {
      company: 'Hela {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS står för Employee Net Promoter Score och är ett mått på hur villiga medarbetarna är att rekommendera sin arbetsgivare till en vän eller en bekant.',
      nps_description:
        'NPS står för Net Promoter Score och är ett mått på hur villiga människor är att rekommendera något till en vän eller en bekant.',
      nps_detractors: 'Kritiker',
      nps_passives: 'Passiva',
      nps_promoters: 'Förespråkare',
      value:
        'Det här är genomsnittsvärdet för alla frågor inom "{tagName}" som besvarats av {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} över tid',
    twoTags: '{tag1} och {tag2}'
  }
}
